import { render } from "./HaulerForm.vue?vue&type=template&id=4228325a"
import script from "./HaulerForm.vue?vue&type=script&lang=js"
export * from "./HaulerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__